"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var contexts_1 = require("../../contexts");
var Form_1 = __importDefault(require("../Form"));
var MasterDetailForm = function (props) {
    var children = props.children;
    var _a = react_1.useContext(contexts_1.MasterContext), selectedItem = _a.selectedItem, handleSubmit = _a.handleSubmit;
    return (react_1.default.createElement(Form_1.default, __assign({ initialValues: selectedItem, onSubmit: handleSubmit }, props), children));
};
exports.default = MasterDetailForm;
